var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIdentification(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47852 15.0001C9.93145 15.0001 11.3249 14.423 12.3523 13.3956C13.3796 12.3682 13.9568 10.9748 13.9568 9.52186V6.47836C13.9585 5.13038 13.4613 3.82945 12.5611 2.82617",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 7.69531V9.52141C2.99971 10.5989 3.31716 11.6525 3.91264 12.5505C4.50812 13.4485 5.35518 14.1509 6.34784 14.57",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2177 1.73392C10.4073 1.26602 9.49046 1.01353 8.55473 1.00053C7.619 0.987526 6.69554 1.21444 5.87241 1.65964C5.04927 2.10484 4.3539 2.75348 3.85261 3.5437C3.35131 4.33393 3.06081 5.2394 3.00879 6.17377",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65234 9.52193C6.65234 10.0062 6.84474 10.4707 7.18719 10.8132C7.52965 11.1556 7.99413 11.348 8.47844 11.348C8.96275 11.348 9.42723 11.1556 9.76969 10.8132C10.1121 10.4707 10.3045 10.0062 10.3045 9.52193V6.47844C10.3045 5.99413 10.1121 5.52965 9.76969 5.1872C9.42723 4.84474 8.96275 4.65234 8.47844 4.65234C7.99413 4.65234 7.52965 4.84474 7.18719 5.1872C6.84474 5.52965 6.65234 5.99413 6.65234 6.47844V8.30454",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.47852 7V8.8261",
    stroke: "black",
    strokeWidth: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdentification);
export default __webpack_public_path__ + "static/media/Identification.3d5e92f276d6a605b9419acda7edafba.svg";
export { ForwardRef as ReactComponent };